import { queryOptions } from '@tanstack/react-query'
import { getBalanceFn, GetBalanceQueryRootKey } from '../gen/service/creativefabrica/coins/v2'

export const BALANCE_QUERY_VARIABLES = {}

export function getBalanceQueryKey(
  variables = BALANCE_QUERY_VARIABLES,
  workspaceId: string | null,
) {
  return workspaceId
    ? ([GetBalanceQueryRootKey, variables, workspaceId] as const)
    : ([GetBalanceQueryRootKey, variables] as const)
}

export function getBalanceQueryOptions(
  variables = BALANCE_QUERY_VARIABLES,
  workspaceId: string | null,
) {
  return queryOptions({
    queryKey: getBalanceQueryKey(variables, workspaceId),
    queryFn: () =>
      getBalanceFn(variables, {
        // Shared with the Team app, which supplies its own selected team.
        // Keep the request workspace aligned with its cache key, even if Studio's selection changes.
        // Personal queries must omit x-team-id rather than inherit the selected team.
        skipDefaultRequestHeaders: true,
        headers: workspaceId ? new Headers({ 'x-team-id': workspaceId }) : undefined,
      }),
  })
}
